'use strict';
var cachedSize = {};

exports.measureTextWidth = function (style, text) {
  var domCom;
  var cacheKey = JSON.stringify(style) + text;

  if (cachedSize[cacheKey]) {
    return cachedSize[cacheKey];
  }

  domCom = document.getElementById('measure');
  domCom.innerText = text;
  domCom.style.fontSize = style.fontSize + 'px';
  domCom.style.fontStyle = style.fontStyle;
  domCom.style.textDecoration = style.textDecoration;
  domCom.style.fontWeight = style.fontWeight;
  domCom.style.fontFamily = style.fontFamily;


  cachedSize[cacheKey] = {
    width: domCom.clientWidth,
    height: domCom.clientHeight
  };
  return {
    width: domCom.clientWidth,
    height: domCom.clientHeight
  };
};





/** WEBPACK FOOTER **
 ** ./src/helper/measureHelper.js
 **/